import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import GroupTitle from "./GroupTitle";
import paymentApi from "../../../common/api/paymentApi";
import { PaymentProviderListType } from "../../../common/types";
import { Checkbox } from "../Elements";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import PaymentProviderSelectBox from "./PaymentProviderSelectBox";
import useOutsideClick from "../../../hooks/useClickOutside";
import { isBankSelectable } from "../../../common/helpers/isBankSelectable";


type Props = {
    licenseKey: string,
    taxCode: string,
    onChangeSelected: (item: PaymentProviderListType) => void,
    selectedPaymentProvider: number,
    isPaymentProviderSelectable: boolean,
    setIsPaymentProviderSelectable: (isSelect: boolean) => void,
    currencyId: number,
}
const PaymentProvidersV1 = React.forwardRef((props: Props, ref) => {



    const { licenseKey, taxCode, onChangeSelected, selectedPaymentProvider, isPaymentProviderSelectable, setIsPaymentProviderSelectable } = props;

    const selectboxRef = useRef(null);


    const [paymentProviderList, setPaymentProviderList] = useState<Array<PaymentProviderListType>>([]);
    const [isPaymentproviderListVisible, setIsPaymentproviderListVisible] = useState(true);
    const [paymentProviderSelectShow, setPaymentProviderSelectShow] = useState(false);

    useEffect(() => {
        if (isPaymentproviderListVisible) {
            selectPaymentProviders();
        }
        setIsPaymentproviderListVisible(isBankSelectable());
    }, []);



    const showPaymentProviderSelectBox = () => setPaymentProviderSelectShow(true);
    const hidePaymentProviderSelectBox = () => setPaymentProviderSelectShow(false);

    const selectPaymentProviders = async () => {

        const method = `posintegration/all-from-web`;
        const apiParams = { licenseKey: licenseKey, taxCode: taxCode };


        const { data, errorMessage, isSuccess } = await paymentApi.get(method, null, apiParams);

        if (isSuccess) {
            setPaymentProviderList(data);
        }
    }

    const showPaymentProviderSelectBoxControl = () => {

        if (isPaymentproviderListVisible && isPaymentProviderSelectable) {
            showPaymentProviderSelectBox();
        }
    }

    const onSelectPaymentProvider = (item: PaymentProviderListType) => {

        hidePaymentProviderSelectBox();

        onChangeSelected(item);
    }
    const getSelectedItem = (): any => {
        const index = paymentProviderList.findIndex(w => w.vpid == selectedPaymentProvider);
        if (index != -1) {
            return paymentProviderList[index];
        }
        return {};
    }
    const selectedVp = getSelectedItem();


    useOutsideClick(selectboxRef, hidePaymentProviderSelectBox);

    const getPaymentProviderListWithFilter = () => {


        if (props.currencyId != 1) {
            let multyiCurrencyProviders = paymentProviderList.filter(function (el) {
                return el.isMultipleCurrency == true
            });
            return multyiCurrencyProviders;
        } else {
            return paymentProviderList
        }
    }

    const paymentProviders = getPaymentProviderListWithFilter();

    return (
        <div className="w-full mt-6 bg-white ">

            <GroupTitle title="Ödeme Altyapısı" />

            {isPaymentproviderListVisible && (
                <Checkbox
                    label={"Ödeme Altyapısını Seçmek İstiyorum"}
                    name={"isPublicPaymnet"}
                    inputContainerClass=" mt-4"
                    id="isPublicPaymnet"
                    type="checkbox"
                    onChange={(e: any) => setIsPaymentProviderSelectable(e.target.checked)}
                    defaultValue={isPaymentProviderSelectable}
                />
            )}

            <div className="w-full relative" ref={selectboxRef}>
                <div
                    onClick={showPaymentProviderSelectBoxControl}
                    className={`h-20 border border-light-border rounded-lg mt-4 flex items-center justify-between p-4 cursor-pointer 
                    ${paymentProviderSelectShow ? "shadow-lg border-b-0 rounded-b-none rounded-t-lg" : "rounded-lg"}
                    `}>

                    {selectedPaymentProvider > 0 ? (
                        <div className="flex items-center">
                            <img src={"/" + selectedVp.bankImagePath} alt="" className="w-[50px]" />

                            <label className="ml-2 text-[13px]">
                                {selectedVp.vpdisplayname}
                            </label>
                        </div>
                    ) : (
                        <div className="">
                            Ödeme altyapısını görmek için kart bilgilerini giriniz
                        </div>
                    )}
                    {
                        isPaymentProviderSelectable && (
                            <FontAwesomeIcon icon={faChevronDown} color="#ADA7A7" size="xl" />
                        )
                    }
                </div>
                <PaymentProviderSelectBox paymentProviderList={paymentProviders} onSelect={onSelectPaymentProvider}
                    selectedPaymentProvider={selectedPaymentProvider}
                    show={paymentProviderSelectShow}
                />


            </div>

        </div>
    );
})
export default PaymentProvidersV1